import { Container, Card, CardBody, CardTitle, ListGroup, ListGroupItem, CardHeader, Row, Col } from 'reactstrap';
import './Skills.css';

function Skills() {
  return (
    <Container id="skills" className='Skills'>
      <Card>
        <CardHeader>
          <CardTitle tag="h2">Skills:</CardTitle>
        </CardHeader>
        <CardBody><Row>
          <Col xs="12" md="4"><Card className="subCard">
            <CardHeader><CardTitle tag='h3'>Languages:</CardTitle></CardHeader>
            <CardBody>
              <ListGroup>
                <ListGroupItem>Java</ListGroupItem>
                <ListGroupItem>Python</ListGroupItem>
                <ListGroupItem>C++</ListGroupItem>
                <ListGroupItem>C</ListGroupItem>
                <ListGroupItem>C#</ListGroupItem>
                <ListGroupItem>HTML</ListGroupItem>
                <ListGroupItem>CSS</ListGroupItem>
                <ListGroupItem>JavaScript</ListGroupItem>
                <ListGroupItem>SQL</ListGroupItem>
                <ListGroupItem>UML</ListGroupItem>
              </ListGroup>
            </CardBody>
          </Card></Col>
          
          <Col xs="12" md="4"><Card className="subCard">
            <CardHeader><CardTitle tag="h3">Operating Systems:</CardTitle></CardHeader>
            <CardBody>
              <ListGroup>
                <ListGroupItem>Linux / Unix</ListGroupItem>
                <ListGroupItem>Microsoft Windows</ListGroupItem>
                <ListGroupItem>MacOS</ListGroupItem>
                <ListGroupItem>Microsoft Windows Server</ListGroupItem>
              </ListGroup>
            </CardBody>
          </Card></Col>

          <Col xs="12" md="4"><Card className="subCard">
            <CardHeader><CardTitle tag="h3">Frameworks:</CardTitle></CardHeader>
            <CardBody>
              <ListGroup>
                <ListGroupItem>React</ListGroupItem>
                <ListGroupItem>Angular</ListGroupItem>
                <ListGroupItem>Svelte</ListGroupItem>
              </ListGroup>
            </CardBody>
          </Card></Col>
        </Row></CardBody>

      </Card>
    </Container>
  );
}

export default Skills;
